module.exports = __webpack_public_path__ + "img/Press_Release_RemitPro_X_Ria_Financial_Services.29db4b57.jpeg";